import React from 'react';
import { styled, Menu, MenuItem } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { ConnectButton } from './sharepoint/ConnectButton';
import FolderIcon from '@mui/icons-material/Folder';

interface AdvancedMenuProps {
    anchorEl: HTMLElement | null;
    setAnchorEl: React.Dispatch<React.SetStateAction<HTMLElement | null>>;
    setSharepointModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    updateFiles: (incomingFiles: any[]) => void;
    isSharepointAuth: boolean;
    setIsSharepointAuth: React.Dispatch<React.SetStateAction<boolean>>;
    acceptedFiles: string;
}

export const AdvancedMenu = ({
    anchorEl,
    setAnchorEl,
    setSharepointModalOpen,
    updateFiles,
    isSharepointAuth,
    setIsSharepointAuth,
    acceptedFiles,
}: AdvancedMenuProps) => {
    const open = Boolean(anchorEl);

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const openSharepointSelector = () => {
        setSharepointModalOpen(true);
        handleCloseMenu();
    };

    const handleFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const fileList = e.target.files;
        if (!fileList) return;
        const incomingFiles = Array.from(fileList).map((file, index) => ({
            id: Date.now() + index,
            file,
        }));
        updateFiles(incomingFiles);
        e.target.value = '';
    };

    const VisuallyHiddenInput = styled('input')({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        bottom: 0,
        left: 0,
        whiteSpace: 'nowrap',
        width: 1,
    });

    return (
        <Menu
            id="demo-positioned-menu"
            aria-labelledby="demo-positioned-button"
            anchorEl={anchorEl}
            open={open}
            onClose={handleCloseMenu}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
        >
            <MenuItem>
                <label
                    htmlFor="file-input"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        width: '100%',
                    }}
                >
                    <AttachFileIcon sx={{ mr: 1 }} />
                    Adjuntar archivos
                    <VisuallyHiddenInput
                        id="file-input"
                        type="file"
                        multiple
                        accept={acceptedFiles}
                        onChange={(e) => {
                            handleFileInputChange(e);
                            handleCloseMenu();
                        }}
                    />
                </label>
            </MenuItem>

            {!isSharepointAuth && (
                <MenuItem onClick={handleCloseMenu}>
                    <ConnectButton
                        setIsSharepointAuth={setIsSharepointAuth}
                        setSharepointModalOpen={setSharepointModalOpen}
                    />
                </MenuItem>
            )}
            {isSharepointAuth && (
                <MenuItem onClick={openSharepointSelector}>
                    <FolderIcon sx={{ mr: 1 }} />
                    Seleccionar archivos o carpetas desde SharePoint
                </MenuItem>
            )}
        </Menu>
    );
};
